var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxUkrainian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0001C24 13.4026 23.7593 14.7489 23.3171 16C21.67 20.6608 17.2249 24.0001 12 24.0001C6.77504 24.0001 2.32994 20.6608 0.6828 16C0.240593 14.7489 0 13.4026 0 12.0001H24Z",
    fill: "#FFD948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H0C0 10.5975 0.240593 9.25123 0.6828 8.00012C2.32994 3.33936 6.77504 0 12 0C17.2249 0 21.67 3.33936 23.3171 8.00012C23.7593 9.25123 24 10.5975 24 12Z",
    fill: "#156DD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxUkrainian);
export default __webpack_public_path__ + "static/media/px-ukrainian.45a43f95f83e4bcc13fd985533f6852e.svg";
export { ForwardRef as ReactComponent };